/* import __COLOCATED_TEMPLATE__ from './email-otp.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';
import type EmailOtp from 'embercom/models/operator/visual-builder/step/email-otp';
import type ConnectionPoint from 'embercom/models/operator/visual-builder/connection-point';
import type EditorState from 'embercom/objects/workflows/graph-editor/editor-state';

interface Signature {
  Args: {
    step: EmailOtp;
    stepConfig: any;
    editorState: EditorState;
    updateConnectionPoints: () => void;
    connectionPointComponent: any;
    readOnly: boolean;
  };
}

export default class EmailOtpComponent extends Component<Signature> {
  get fallbackBranch(): ConnectionPoint | undefined {
    return this.args.step.outwardConnectionPoints?.find(
      (cp: ConnectionPoint) => cp.type === 'fallback',
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::EmailOtp': typeof EmailOtpComponent;
  }
}
